<template>
  <v-app>
    <!-- Mobile Navigation Drawer (slides in from right on small screens) -->
    <v-navigation-drawer
        v-model="drawer"
        app
        temporary
        right
        color="#121212"
        dark
        width="230"
    >
      <div class="drawer-header">
        <span class="drawer-name">Ali Bayani</span>
      </div>
      <v-divider></v-divider>
      <v-list nav dense class="mt-2">
        <v-list-item
            v-for="item in navItems"
            :key="item.href"
            class="drawer-item"
        >
          <a
              :href="item.href"
              class="drawer-link"
              @click="drawer = false"
          >{{ item.label }}</a>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <!-- Top App Bar -->
    <v-app-bar
        flat
        color="#121212"
        elevation="1"
        app
        dark
    >
      <v-toolbar-title class="font-weight-bold ml-2">
        Ali Bayani
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <!-- Desktop nav links (hidden on mobile) -->
      <nav aria-label="Page sections" class="d-none d-md-flex align-center">
        <a
            v-for="item in navItems"
            :key="item.href"
            :href="item.href"
            class="nav-link mr-4 white--text"
        >{{ item.label }}</a>
      </nav>

      <!-- Mobile hamburger button (hidden on desktop) -->
      <v-app-bar-nav-icon
          class="d-flex d-md-none"
          @click="drawer = !drawer"
          aria-label="Open navigation menu"
      ></v-app-bar-nav-icon>
    </v-app-bar>

    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      drawer: false,
      navItems: [
        { href: '#publications', label: 'Publications'   },
        { href: '#projects',     label: 'Projects'       },
        { href: '#honors',       label: 'Honors & Awards'},
        { href: '#teaching',     label: 'Teaching'       },
        { href: '#peerreview',   label: 'Peer Review'    },
        { href: '#contact',      label: 'Contact'        },
      ]
    };
  }
};
</script>

<style>
/* ── Global ── */
body, html {
  margin: 0;
  padding: 0;
  font-family: 'InterVariable', sans-serif;
  background-color: #121212;
  color: #ffffff;
}

/* Offset for sticky app-bar when jumping to anchors */
#publications,
#projects,
#honors,
#teaching,
#peerreview,
#contact {
  scroll-margin-top: 70px;
}

/* ── Desktop nav links ── */
.nav-link {
  color: #ffffff !important;
  text-decoration: none;
  font-size: 0.95rem;
  font-weight: 500;
  transition: color 0.2s ease;
}
.nav-link:hover { color: #D4AF37 !important; }

/* ── Mobile drawer ── */
.drawer-header {
  padding: 20px 16px 12px;
}
.drawer-name {
  font-size: 1.05rem;
  font-weight: 700;
  color: #ffffff;
  letter-spacing: 0.01em;
}
.drawer-item {
  padding: 2px 0;
}
.drawer-link {
  display: block;
  width: 100%;
  padding: 10px 16px;
  color: #e0e0e0;
  text-decoration: none;
  font-size: 0.95rem;
  font-weight: 500;
  border-radius: 6px;
  transition: color 0.2s ease, background 0.2s ease;
}
.drawer-link:hover {
  color: #D4AF37;
  background: rgba(212, 175, 55, 0.08);
}

/* ── Scrollbar ── */
::-webkit-scrollbar { width: 0; }
</style>
